import { Button } from "@bvhi/ui-base";
import { AddIcon } from "@bvhi/ui-icons";
import { NavigateOptions, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  navigateTarget: NavigateOptions;
  entity: string;
}

export const BVHINavigationCreateEntityButton = ({ navigateTarget, entity }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);

  const handleButtonClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      void navigate(navigateTarget);
    },
    [navigate, navigateTarget]
  );

  return (
    <Button color="primary" onClick={handleButtonClick} startIcon={<AddIcon />} variant="contained">
      {t("common:button.create", { value: entity })}
    </Button>
  );
};
